import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Form } from "formik";
import { AddButton } from "../../../../components/Buttons/AddButton";

export const AccordianWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  "& .MuiSelect-root": {
    zIndex: 9999
  },
  "& .MuiOutlinedInput-root ": {
    "& fieldset": {
      background: "#fff"
    }
  },
  "& .MuiOutlinedInput-input": {
    zIndex: 2,
    margin: "2px"
  },
  "& textarea": {
    zIndex: 2
  }
}));

export const PageTitle = styled(Box)({
  fontSize: "48px",
  lineHeight: 1.17
});

export const TopIndent = styled(Box)({
  marginTop: "40px"
});

export const FormStyle = styled(Form)(({ theme }) => ({
  width: "100%",
  "& .MuiGrid-root": {
    "&> .MuiGrid-item": {
      paddingTop: "24px"
    }
  },
  "& .selectCombined > div:first-of-type fieldset": {
    borderColor: "#c2c2c2"
  }
}));

export const Title = styled(Box)(({ theme }) => ({
  marginLeft: "20px",
  fontSize: "20px",
  fontWeight: 600,
  color: theme.palette.text.primary
}));

export const Username = styled(Box)(({ theme }) => ({
  fontSize: "20px",
  lineHeight: "1.3",
  margin: 0,
  color: theme.palette.text.primary
}));

export const SectionTitleIndent = styled(Box)({
  marginBottom: "60px"
});

export const ContinueButton = styled(Box)({
  margin: "20px 0 40px 0"
});

export const DetailsContinueButton = styled(Box)({
  marginTop: 5
});

export const ContinueButtonGrid = styled(Box)({
  padding: 20
});

export const DeleteButton = styled(Box)({
  backgroundColor: "#fff",
  float: "right",
  position: "inherit",
  marginRight: "20px",
  padding: "5px 10px",
  borderRadius: "20px",
  "& span": {
    textDecoration: "none"
  }
});

export const ContinueButtonContainer = styled(Box)(({ theme }) => ({
  flexWrap: "nowrap",
  [theme.breakpoints.only("xs")]: {
    flexDirection: "column"
  }
}));

export const ContinueBtn = styled(Box)(({ theme }) => ({
  [theme.breakpoints.only("xs")]: {
    alignSelf: "flex-end",
    marginTop: "10px"
  }
}));

export const RadioButtonRoot = styled(Box)({
  width: "calc(33.33% - 20px)",
  padding: 5
});

export const UploadButton = styled(Box)({
  background: "none",
  border: "1px solid #000000",
  marginLeft: 10,
  padding: "5px 32px",
  minHeight: 30,
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.1)"
  }
});

export const LabelStyle = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main
}));

export const MapPreviewContainer = styled(Box)({
  height: 250,
  borderRadius: 10,
  margin: 10,
  width: "100%",
  marginBottom: 150
});

export const PreviewContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    position: "relative",
    right: "auto",
    width: "100%"
  }
}));

export const FileUploadPlaceholder = styled(Box)({
  backgroundColor: "#fff",
  borderRadius: 8,
  display: "flex",
  alignItems: "center",
  padding: "18.5px 14px",
  border: "solid 1px rgba(230, 230, 230, 0.5)"
});

export const ContentBox = styled(Box)({
  alignItems: "center",
  flexGrow: 1,
  padding: "7px 18px"
});

export const DefaultInput = styled("input")({
  display: "none"
});

export const ControlsBox = styled(Box)({
  width: "130px",
  height: "32px",
  borderRadius: "21px",
  border: "solid 1px #373737",
  fontSize: "14px",
  fontWeight: "normal",
  fontStyle: "normal",
  fontStretch: "normal",
  letterSpacing: "normal",
  textAlign: "center",
  color: "#373737",
  cursor: "pointer",
  lineHeight: "2.2"
});

export const Button = styled(AddButton)({
  marginTop: "10px",
  marginRight: "20px",
  padding: "5px 10px",
  "& span": {
    textDecoration: "none"
  }
});
